import React from 'react';

if (process.browser) require('./Card.scss');

export default function Card({
  title,
  className = '',
  children,
  container,
  fullHeight,
  ...props,
}) {
  return (
    <div
      className={`card ${className} ${container ? 'with-container' : ''} ${fullHeight ? 'card-full-height' : ''}`}
      {...props}
    >
      { title && <h4 data-name="title">{ title }</h4> }
      { children }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Card/Card.js